<!-- components/CommonHeader.vue -->
<template>
  <div class="flex-center">
    <v-app-bar app fixed elevation="0" class="flex-center h-88-62 spacing-pa-16-4">
        <template v-if="!isSm">
          <a class="mr-5" href="#" @click.prevent="goToTopPage">
              <img class="max-w-280-200" :src="require('@/assets/header/kaeruHeader.svg')"/>
          </a>
          <a class="mr-5" href="https://www.city.setagaya.lg.jp/" rel="noopener noreferrer" target="_blank">
              <img class="max-w-140-80" :src="require('@/assets/header/setagaya.svg')"/>
          </a>
          <v-spacer />
          <a class="mr-8 font-16-18" href="#" @click.prevent="goToPlanSection" style="color: black !important;">再エネ電気プランとは？</a>
          <a class="mr-8 font-16-18" href="#" @click.prevent="goToFlowSection" style="color: black !important;">利用までの流れ</a>
          <a class="mr-8 font-16-18" href="#" @click.prevent="goToFaqSection" style="color: black !important;">よくあるご質問</a>
          <v-btn class="flex-center-y font-16-18" style="background-color: var(--red); color: white; border-radius: 100px; box-shadow: none; height: 60px;" @click="goToSearchWithDialog()">
            <div class="flex-center flex-column">
                <div class="font-16-18">CO₂も電気代も！</div>
                <div class="font-16-18">5秒で簡単チェック！</div>
            </div>
            <v-icon right class="mt-1">mdi-arrow-right-circle</v-icon>
          </v-btn>
        </template>
        <template v-else>
          <v-row class="flex-center pa-1">
            <a href="#" @click.prevent="goToTopPage">
              <img class="max-w-280-200" :src="require('@/assets/header/kaeruHeader.svg')"/>
            </a>
            <v-spacer/>
            <a href="https://www.city.setagaya.lg.jp/" rel="noopener noreferrer" target="_blank">
              <img class="max-w-140-120" :src="require('@/assets/header/setagaya.svg')"/>
            </a>
            <v-spacer/>
            <v-app-bar-nav-icon @click="drawer = !drawer" />
          </v-row>
        </template>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" app temporary location="right" class="font-18-18 pa-5 ma-0" width="500" v-if="isSm">
      <v-list>
        <v-list-item @click="handleGoToPlan">
          <div class="space-evenly">
            <span>再エネ電気プランとは？</span>
            <v-spacer />
            <v-icon right>mdi-chevron-right</v-icon>
          </div>
        </v-list-item>
        <v-list-item @click="handleGoToFlow">
          <div class="space-evenly">
            <span>利用までの流れ</span>
            <v-spacer />
            <v-icon right>mdi-chevron-right</v-icon>
          </div>
        </v-list-item>
        <v-list-item @click="handleGoToFaq">
          <div class="space-evenly">
            <span>よくあるご質問</span>
            <v-spacer />
            <v-icon right>mdi-chevron-right</v-icon>
          </div>
        </v-list-item>
        <v-spacer class="spacing-h-30-30"/>
        <v-list-item class="flex-center" @click="handleGoToSearch">
          <v-btn class="sm-header-simulation-btn">
          <!-- テキスト部分 -->
          <div class="flex-center flex-column">
              <div class="font-24-12">CO₂も電気代も！</div>
              <div class="font-38-20">5秒で簡単チェック！</div>
          </div>
          <!-- 右端矢印 -->
          <v-icon right size="30">mdi-arrow-right-circle</v-icon>
          </v-btn>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script setup>
import { ref, computed, unref } from 'vue'
import { useRouter } from 'vue-router'
import { useDisplay } from 'vuetify'
import './main.css'
import { useRoute } from 'vue-router'

const route = useRoute()

// Vuetify のレスポンシブ判定
const display = useDisplay()
const isSmDispLay = computed(() => display.smAndDown)
const isSm = unref(isSmDispLay)

// Vue Router
const router = useRouter()

// ハンバーガーメニューの開閉状態
const drawer = ref(false)

// 固定ヘッダーに応じてスクロール補正
function scrollToTarget(id) {
  const headerOffset = isSm ? 90 : 60
  const element = document.getElementById(id)

  if (element) {
    const elementPosition = element.getBoundingClientRect().top
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    })
  }
}

// ページ遷移 or スクロール関数
function goToTopPage() {
  router.push({ name: 'TopPage' })
}
function goToPlanSection() {
  if (route.name === 'TopPage') {
    scrollToTarget('section-plan')
  } else {
    router
      .push({ name: 'TopPage', query: { scrollTo: 'section-plan' } })
  }
}
function goToFlowSection() {
  if (route.name === 'TopPage') {
    scrollToTarget('section-flow')
  } else {
    router
      .push({ name: 'TopPage', query: { scrollTo: 'section-flow' } })
  }
}
function goToFaqSection() {
  if (route.name === 'TopPage') {
    scrollToTarget('section-faq')
  } else {
    router
      .push({ name: 'TopPage', query: { scrollTo: 'section-faq' } })
  }
}
function goToSearchWithDialog() {
  router.push({ name: 'Search', query: { showDialog: 'true' } })
}

// ハンバーガーメニュー内用の関数（+ drawer を閉じる）
function handleGoToPlan() {
  goToPlanSection()
  drawer.value = false
}
function handleGoToFlow() {
  goToFlowSection()
  drawer.value = false
}
function handleGoToFaq() {
  goToFaqSection()
  drawer.value = false
}
function handleGoToSearch() {
  goToSearchWithDialog()
  drawer.value = false
}
</script>


